import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import * as manualGuideService from "../../../services/manual-guide.service";
import Breadcrums from "../../../common/breadcrumbs";
import Loader from "../../../common/loader";
import { breakWord, formateDate } from "../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";

export default function ManualGuideViewLayout() {
      const {t} = useTranslation();
      const loc = useLocation();
      const navigate = useNavigate();
      const params = useParams();
    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        {
          title: "Manual Guide",
          url: "/admin/manual-guide/list/1",
        },
        { title: t("btn_view"), url: "" },
      ];
  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">
                  View manual guide
                </h6>
              </div>
              <div className="tabs-wrap">
                <div className="profile-tab tab-menu-heading mb-4">
                  <nav className="nav main-nav-line p-3 tabs-menu profile-nav-line bg-gray-100">
                    <Link className={"nav-link linkactive " + (loc.pathname === "/admin/manual-guide/view/" + params?.id+"/general" ? " active" : "")}
                      aria-current="page" to={"/admin/manual-guide/view/" + params?.id+"/general"} >
                      General
                    </Link>
                    <Link className={"nav-link linkactive " + (loc.pathname === "/admin/manual-guide/view/" + params?.id+"/modules" ? " active" : "")}
                      aria-current="page" to={"/admin/manual-guide/view/" + params?.id+"/modules"} >
                      Modules
                    </Link>
                    {/* <Link className={"nav-link linkactive " + (loc.pathname === "/admin/manual-guide/view/" + params?.id+"/modules-images" ? " active" : "")}
                      aria-current="page" to={"/admin/manual-guide/view/" + params?.id+"/modules-images"} >
                      Modules Images
                    </Link> */}
                  </nav>
                </div>
                <Outlet />
              </div>
            </div>

            <div className="mt-5 back-button">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() =>
                  navigate("/admin/manual-guide/list/1")
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
